import React from 'react';
import { Table, Spinner, Alert, Button } from 'react-bootstrap';

const TablaAvisos = ({ avisos, isLoading, onFiltrarPorEjecutivo, onFiltrarPorEmpresaCliente }) => {
  if (isLoading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status" variant="primary" />
        <p className="mt-3">Cargando datos...</p>
      </div>
    );
  }

  if (!avisos || avisos.length === 0) {
    return (
      <Alert variant="warning" className="text-center p-4">
        <Alert.Heading>No se encontraron resultados</Alert.Heading>
        <p>No se encontraron avisos que coincidan con los filtros seleccionados.</p>
        <p>Por favor, intente con diferentes criterios de búsqueda.</p>
      </Alert>
    );
  }

  // Formatear valor monetario
  const formatearMoneda = (valor) => {
    if (!valor) return '$0';
    return `$${parseInt(valor).toLocaleString('es-CL')}`;
  };
  
  // Manejadores para los filtros al hacer clic
  const handleEjecutivoClick = (ejecutivo) => {
    if (onFiltrarPorEjecutivo) {
      onFiltrarPorEjecutivo(ejecutivo);
    }
  };
  
  const handleEmpresaClienteClick = (empresaCliente) => {
    if (onFiltrarPorEmpresaCliente) {
      onFiltrarPorEmpresaCliente(empresaCliente);
    }
  };

  return (
    <div className="tabla-avisos-container">
      <Table striped bordered hover responsive className="mb-4">
        <thead className="bg-primary text-white">
          <tr>
            <th>Nid</th>
            <th>Título</th>
            <th>Valor con descuento</th>
            <th>Fecha de publicación</th>
            <th>Ejecutivo</th>
            <th>Empresa proveedora</th>
            <th>Estado aviso impreso</th>
            <th>Empresa cliente</th>
          </tr>
        </thead>
        <tbody>
          {avisos.map((aviso) => (
            <tr key={aviso.nid}>
              <td>{aviso.nid}</td>
              <td>{aviso.titulo}</td>
              <td className="text-end">{formatearMoneda(aviso.valor_con_descuento)}</td>
              <td>{aviso.fecha_publicacion}</td>
              <td>
                {aviso.ejecutivo && (
                  <Button 
                    variant="link" 
                    className="p-0 text-primary text-decoration-none"
                    onClick={() => handleEjecutivoClick(aviso.ejecutivo)}
                  >
                    {aviso.ejecutivo}
                  </Button>
                )}
              </td>
              <td>
                {aviso.empresa_proveedora === 'ANTONIO PUGA Y CIA LTDA' ? (
                  <span className="badge bg-info text-dark">ANTONIO PUGA Y CIA LTDA</span>
                ) : aviso.empresa_proveedora === 'PRENSA DEL LÍMARI' ? (
                  <span className="badge bg-secondary">PRENSA DEL LÍMARI</span>
                ) : (
                  aviso.empresa_proveedora || 'No asignado'
                )}
              </td>
              <td>
                {aviso.estado_aviso_impreso === 'Publicado' || aviso.estado_aviso_impreso === 'Estado 71' ? (
                  <span className="badge bg-success">Publicado</span>
                ) : aviso.estado_aviso_impreso === 'Pendiente' || aviso.estado_aviso_impreso === 'Estado 68' ? (
                  <span className="badge bg-warning text-dark">Pendiente</span>
                ) : (
                  <span className="badge bg-secondary">{aviso.estado_aviso_impreso}</span>
                )}
              </td>
              <td>
                {aviso.empresa_cliente && (
                  <Button 
                    variant="link" 
                    className="p-0 text-primary text-decoration-none"
                    onClick={() => handleEmpresaClienteClick(aviso.empresa_cliente)}
                  >
                    {aviso.empresa_cliente}
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="bg-light">
          <tr>
            <td colSpan="2" className="text-end fw-bold">Total:</td>
            <td className="text-end fw-bold">
              {formatearMoneda(
                avisos.reduce((total, aviso) => total + parseFloat(aviso.valor_con_descuento || 0), 0)
              )}
            </td>
            <td className="text-end fw-bold" colSpan="2">{avisos.length} {avisos.length === 1 ? 'Aviso' : 'Avisos'}</td>
            <td colSpan="3"></td>
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default TablaAvisos; 